import { render, staticRenderFns } from "./transitionMain.vue?vue&type=template&id=6720a86c&scoped=true&"
import script from "./transitionMain.vue?vue&type=script&lang=js&"
export * from "./transitionMain.vue?vue&type=script&lang=js&"
import style0 from "./transitionMain.vue?vue&type=style&index=0&id=6720a86c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6720a86c",
  null
  
)

export default component.exports